import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { Message } from "../../models/message";
import Helpers from "../../utils/helpers";

@Injectable()
export class MessageControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getMessagesList(): Observable<Message[]> {
    return this.http.get(this.baseUrl + "message") as Observable<Message[]>;
  }

  public getServiceMessagesListByPage(serviceId: string, page: number = 0, size: number = 30, filter: string, sortKey: string = "name", asc: string = "asc", channel: string = null): Observable<any> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/message?page=" + page + "&sort=" + sortKey + "," + asc + (size ? ("&size=" + size) : "") + (filter ? ("&nameFilter=" + filter) : "") + (channel ? ("&channel=" + channel) : "")) as Observable<any>;
  }

  public getMessagesListByPage(page: number = 0, size: number = 30, filter: string, sortKey: string = "name", asc: string = "asc", excludeService: string = null, channel: string = null): Observable<any> {
    return this.http.get(this.baseUrl + "message?page=" + page + "&sort=" + sortKey + "," + asc + (size ? ("&size=" + size) : "") + (filter ? ("&nameFilter=" + filter) : "") + (excludeService ? ("&excludeServiceMessages=" + excludeService) : "") + (channel ? ("&channel=" + channel) : "")) as Observable<any>;
  }

  public getMessage(messageId: string): Observable<Message> {
    return this.http.get(this.baseUrl + "message/" + messageId) as Observable<Message>;
  }

  public saveMessage(message: Message) {
    Helpers.trimRecursiveObj(message);
    const body = JSON.stringify(message);
    return this.http.put(this.baseUrl + "message", body, { responseType: "text" });
  }

  public createMessage(message: Message) {
    Helpers.trimRecursiveObj(message);
    const body = JSON.stringify(message);
    return this.http.post(this.baseUrl + "message", body);
  }

  public deleteMessage(messageId: string) {
    return this.http.delete(this.baseUrl + "message/" + messageId, { responseType: "text" });
  }
}
